import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import minLogo from "../assests/api/images.svg";

import commericalIcon from "../assests/animals/commercialized.svg";
import pipelineIcon from "../assests/animals/growth.svg";
import regulatedIcon from "../assests/animals/box.svg";
import globalCustomerIcon from "../assests/animals/countriespresence.svg";
import apiIcon from "../assests/api/apiIcons.svg";
import fdfIcon from "../assests/api/fdfIcons.svg";
import usfdaIcon from "../assests/api/usfdaIcons.svg";
import batchIcon from "../assests/api/batche.svg";
import backwardIcon from "../assests/api/backwards.svg";
import regulatoryStrengthIcon from "../assests/api/Regulatory.svg";
import ipStrengthIcon from "../assests/api/Intellectual.svg";
import patentFiledIcon from "../assests/api/patentFiled.svg";
import patentGrantedIcon from "../assests/api/patentGranteed.svg";
import successfulPatentIcon from "../assests/api/successfullPatent.svg";
import workforceIcon from "../assests/api/workforce.svg";
import infrastructureIcon from "../assests/api/infrastructure.svg";
import analyticsIcon from "../assests/api/analytics.svg";
import downloadIcon from "../assests/api/download.svg";

import minImage from "../assests/animals/images.svg";
import moleculesIcon from "../assests/animals/molecules.svg";
import minPaw from "../assests/animals/minPaw.svg";
// import apiPhd from "../assests/animals/animalPhd.svg";
// import apiRD from "../assests/animals/animalR&D.svg";
// import apiScientist from "../assests/animals/animalScientist.svg";
// import heroBg from "../assests/api/apiSection.png";

import { FiFilter, FiSearch } from "react-icons/fi";
import AnimatedCounter from "../Shared/AnimatedCounter.js";
import "./index.css";

import broucher from "../assests/broucher.pdf"

const HomeIcon = () => (
    <svg className="api-breadcrumb-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M10 14V8.66667C10 8.48986 9.92976 8.32029 9.80474 8.19526C9.67971 8.07024 9.51014 8 9.33333 8H6.66667C6.48986 8 6.32029 8.07024 6.19526 8.19526C6.07024 8.32029 6 8.48986 6 8.66667V14" stroke="#4A5565" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2 6.66667C1.99995 6.47271 2.04222 6.28108 2.12386 6.10514C2.20549 5.92921 2.32453 5.7732 2.47267 5.648L7.13933 1.64867C7.37999 1.44527 7.6849 1.33368 8 1.33368C8.3151 1.33368 8.62001 1.44527 8.86067 1.64867L13.5273 5.648C13.6755 5.7732 13.7945 5.92921 13.8761 6.10514C13.9578 6.28108 14 6.47271 14 6.66667V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V6.66667Z" stroke="#4A5565" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const stats = [
    {
        icon: <img src={commericalIcon} alt="Commercial APIs" style={{ width: "44px", height: "44px" }} />,
        value: "115+",
        title: "Commercial APIs",
        subtitle: "Presence in 150+ Countries",
        color: "#1f4f82"
    },
    {
        icon: <img src={pipelineIcon} alt="Pipeline Products" style={{ width: "44px", height: "44px" }} />,
        value: "35+",
        title: "Pipeline Products",
        subtitle: "Focused on Oncology & Niche Segments",
        color: "#0e9f6e"
    },
    {
        icon: <img src={regulatedIcon} alt="Global Regulatory Approved Facilities" style={{ width: "44px", height: "44px" }} />,
        value: "9+",
        title: "Global Regulatory Approved Facilities",
        subtitle: "USFDA, EU GMP, WHO-GMP",
        color: "#7c3aed"
    },
    {
        icon: <img src={globalCustomerIcon} alt="Global Customers" style={{ width: "44px", height: "44px" }} />,
        value: "250+",
        title: "Global Customers",
        subtitle: "Across regulated markets",
        color: "#0891B2"
    }
];

const manufacturingStats = [
    {
        icon: <img src={apiIcon} alt="API" style={{ width: "40px", height: "40px", filter: "brightness(0) invert(1)" }} />,
        value: "10",
        label: "API Manufacturing Facilities",
    },
    {
        icon: <img src={fdfIcon} alt="FDF" style={{ width: "40px", height: "40px", filter: "brightness(0) invert(1)" }} />,
        value: "5",
        label: "FDF Facilities",
    },
    {
        icon: <img src={usfdaIcon} alt="USFDA" style={{ width: "40px", height: "40px", filter: "brightness(0) invert(1)" }} />,
        value: "100%",
        label: "USFDA Approved",
    },
    {
        icon: <img src={batchIcon} alt="Batch" style={{ width: "40px", height: "40px", filter: "brightness(0) invert(1)" }} />,
        value: "1–1000 kg",
        label: "Batch Capacity Range",
    },
    {
        icon: <img src={backwardIcon} alt="Backward" style={{ width: "40px", height: "40px", filter: "brightness(0) invert(1)" }} />,
        value: ">85%",
        label: "Backward Integrated",
    },
];

const categorizedProducts = [
    {
        category: "Commercial API's",
        products: [
            // { id: 1, name: "Abacavir Sulphate", category: "Anti-Retroviral", status: "CEP*, DMF" },
            // { id: 5, name: "Agomelatine (Form I) & (Form II)", category: "Anti-Depressant", status: "CNDMF" },
            // { id: 7, name: "Amisulpride", category: "Anti-Psychotic", status: "CEP, EDMF, CNDMF" },
            // { id: 8, name: "Apixaban", category: "Anti-Coagulant", status: "USDME*" },
            // { id: 10, name: "Baclofen", category: "Muscle Relaxant", status: "USDMF, CEP" },
            // { id: 11, name: "Bilastine (Form I) & (Form II)", category: "Anti Histamine", status: "USDMF*, EDMF, CADIFA, CNDMF" },
            // { id: 12, name: "Brimonidine Tartrate", category: "Anti-Glaucoma", status: "USDME, CEP, CADIFA" },
            // { id: 13, name: "Carvedilol", category: "Anti-Hypertensive", status: "CEP, CADIFA" },
            // { id: 14, name: "Carvedilol Phosphate", category: "Anti-Hypertensive", status: "DMF" },
            // { id: 15, name: "Carbinoxamine Maleate", category: "Anti-Histamine", status: "USDMF*" },
            // { id: 16, name: "Cinitapride Hydrogen Tartrate", category: "Prokinetic and antiemetic Agent", status: "EDMF, CNDMF" },
            // { id: 17, name: "Clomiphene Citrate", category: "Ovulatory Stimulants", status: "USDMF*" },
            // { id: 18, name: "Dabrafenib", category: "Anti-Neoplastic", status: "DMF" },
            // { id: 19, name: "Dapoxetine HCl", category: "Treatment of Premature Ejaculation", status: "EDMF, CNDMF" },
            // { id: 20, name: "Dapagliflozin Propanediol Monohydrate", category: "Anti Diabetic", status: "USDMF*" },
            // { id: 21, name: "Deferasirox", category: "Iron Chelator", status: "USDMF, CEP, EDMF, CNDMF" },
            // { id: 22, name: "Dolutegravir Sodium", category: "Anti-Retroviral", status: "USDMF*" },
            // { id: 23, name: "Edoxaban Tosylate", category: "Anti-Coagulant", status: "USDMF*" },
            // { id: 25, name: "Epalrestat", category: "Aldose Reductase Inhibitor", status: "CNDMF" },
            // { id: 26, name: "Eszopiclone", category: "Hypnotic", status: "USDMF, EDMF, CADIFA" },
            // { id: 27, name: "Ezetimibe", category: "Dyslipidemic Agent", status: "USDMF*, CADIFA" },
            // { id: 28, name: "Empagliflozin", category: "Anti Diabetic", status: "USDMF*" },
            // { id: 29, name: "Ferric Carboxy Maltose", category: "Treatment of Anemia", status: "DMF" },
            // { id: 30, name: "Ferric Maltol", category: "Iron Deficiency", status: "DMF" },
            // { id: 31, name: "Finerenone", category: "Cardiovascular", status: "USDMF*" },
            // { id: 32, name: "Flibanserin", category: "Female Aphrodisiac", status: "DMF" },
            // { id: 34, name: "Glycopyrrolate", category: "Anti Cholinergic", status: "USDMF*" },
            // { id: 35, name: "Hydroxychloroquine Sulfate", category: "Anti Malaria", status: "USDMF, CEP*" },
            // { id: 36, name: "Hydroxyzine HCl", category: "Anti Histamine", status: "USDMF, CEP, EDMF, CADIFA" },
            // { id: 37, name: "Hydroxyzine Pamoate", category: "Anti Histamine", status: "USDMF*" },
            // { id: 38, name: "Idrocilamide", category: "Skeletal Muscle Relaxant", status: "DMF" },
            // { id: 39, name: "Iloperidone", category: "Anti-Psychotic", status: "USDMF*" },
            // { id: 42, name: "Iron Sorbitol Dextrin Citric Acid Complex", category: "Hematinic", status: "DMF" },
            // { id: 43, name: "Iron Sucrose LIQ & POW", category: "Hematinic", status: "USDMF*, EDMF" },
            // { id: 44, name: "Iron Polymaltose", category: "Hematinic", status: "DMF" },
            // { id: 45, name: "Itopride HCl", category: "Gastro Prokinetic Agent", status: "EDMF" },
            // { id: 46, name: "Ketorolac Tromethamine", category: "NSAID and Anti-inflammatory", status: "USDMF, CEP, EDMF, CADIFA" },
            // { id: 47, name: "Labetalol Hydrochloride", category: "Anti-Hypertensive", status: "USDMF, CEP" },
            // { id: 48, name: "Lacosamide", category: "Anti-Convulsant", status: "USDMF*, CEP" },
            // { id: 49, name: "Lamivudine", category: "Anti-Retroviral", status: "USDMF*" },
            // { id: 50, name: "Lanthanum Carbonate", category: "Phosphate Binder", status: "USDMF" },
            // { id: 52, name: "Levocetirizine Di HCl", category: "Anti Histamine", status: "USDMF, CEP, EDMF, CADIFA" },
            // { id: 53, name: "Levodropropizine", category: "Anti-Tussive", status: "CEP*" },
            // { id: 54, name: "Levosulpiride", category: "Anti-Psychotic", status: "EDMF*" },
            // { id: 55, name: "Linezolid (Form II) & (Form III)", category: "Anti-Bacterial", status: "USDMF, EDMF, CADIFA, CNDMF" },
            // { id: 56, name: "Linagliptin", category: "Anti Diabetic", status: "USDMF*" },
            // { id: 57, name: "Lopinavir", category: "Anti-Retroviral", status: "DMF" },
            // { id: 58, name: "Losartan Potassium", category: "Anti-Hypertensive", status: "USDMF*, CEP" },
            // { id: 59, name: "Lisdexamfetamine Dimesylate", category: "Treatment of ADHD", status: "DMF" },
            // { id: 60, name: "Mavacamten", category: "Treatment of Heart Pain (OHCM)", status: "USDMF*" },
            // { id: 61, name: "Meclizine HCl", category: "Anti Histamine", status: "USDMF, CEP, CADIFA" },
            // { id: 62, name: "Meprobamate", category: "Anti-Anxiety", status: "USDMF" },
            // { id: 63, name: "Modafinil", category: "Anti-Depressant", status: "USDMF, CEP" },
            // { id: 64, name: "Mosapride Citrate Dihydrate", category: "Gastro Prokinetic Agent", status: "CNDMF" },
            // { id: 67, name: "Olmesartan Medoxomil", category: "Anti-Hypertensive", status: "USDMF*, CEP*" },
            // { id: 68, name: "Ondansetron HCl Dihydrate", category: "Anti Emetic", status: "CEP, CADIFA" },
            // { id: 71, name: "Otilonium Bromide", category: "Irritable Bowel Syndrome (IBS)", status: "USDMF*, CADIFA" },
            // { id: 72, name: "Phentermine HCl", category: "Anorexic", status: "USDMF, CADIFA" },
            // { id: 74, name: "Pregabalin", category: "Anti-Convulsant", status: "CEP, DMF" },
            // { id: 75, name: "Prucalopride Succinate", category: "Gastrointestinal Prokinetic", status: "USDMF, EDMF, CNDMF" },
            // { id: 76, name: "Quinaldic Acid", category: "Anti-Tubercular", status: "DMF" },
            // { id: 77, name: "Racecadotril", category: "Anti Diarrhea", status: "CEP, EDMF, CADIFA, CNDMF" },
            // { id: 78, name: "Resmetirom", category: "Treatment of NASH", status: "DMF" },
            // { id: 79, name: "Ritonavir", category: "Anti-Retroviral", status: "DMF" },
            // { id: 80, name: "Rivaroxaban", category: "Anti-Coagulant", status: "USDMF, CEP, EDMF, CADIFA" },
            // { id: 81, name: "Selexipag IH", category: "Treatment of Pulmonary Hypertension", status: "DMF" },
            // { id: 82, name: "Sertraline HCl (Form-I & Form II)", category: "Anti-Depressant", status: "USDMF*, CEP" },
            // { id: 83, name: "Sucroferric Oxyhydroxide", category: "Treatment of Hyperphosphatemia", status: "USDMF*" },
            // { id: 87, name: "Tamsulosin HCI", category: "Treatment of Benign prostatic hyperplasia (BPH)", status: "DMF" },
            // { id: 88, name: "Tapentadol HCI (Form-A)", category: "Analgesic & Anti-Inflammatory", status: "CEP, EDMF, CADIFA" },
            // { id: 89, name: "Tapentadol Phosphate", category: "Analgesic & Anti-Inflammatory", status: "EDMF" },
            // { id: 90, name: "Thalidomide", category: "Immunomodulator", status: "EDMF" },
            // { id: 91, name: "Tenofovir Disoproxil Fumarate", category: "Anti-Retroviral", status: "USDMF*" },
            // { id: 92, name: "Ticagrelor", category: "Anti-Platelet", status: "USDMF*, CEP" },
            // { id: 93, name: "Tizanidine HCI", category: "Muscle Relaxant", status: "USDMF, CEP, EDMF, CADIFA, CNDMF" },
            // { id: 94, name: "Tofisopam", category: "Anti-Anxiety", status: "EDMF" },
            // { id: 98, name: "Vilazodone", category: "Anti-Depressant", status: "USDMF*, CADIFA" },
            // { id: 99, name: "Viloxazine HCl", category: "Treatment of ADHD", status: "USDMF*, CADIFA" },
            // { id: 100, name: "Vonoprazan Fumarate", category: "Anti-Ulcer", status: "USDMF*, CADIFA" },
            // { id: 101, name: "Vortioxetine HBr", category: "Anti-Depressant", status: "USDMF*, EDMF, CADIFA" },
            // { id: 102, name: "Xanomeline Tartrate", category: "CNS", status: "DMF" }
        ]
    },
    {
        category: "R&D Pipeline API's",
        products: [
            // { id: 2, name: "Acoramidis", category: "Treatment of Cardiomyopathy", status: "Under Pipeline" },
            // { id: 3, name: "Aceclidine", category: "Treatment of Presbyopia (Blurry Vision)", status: "Under Pipeline" },
            // { id: 4, name: "Ademetionine", category: "Treatment of Liver Disorder, Osteoarthritis and Depression", status: "Under Pipeline" },
            // { id: 6, name: "Alpelisib", category: "Anti-Neoplastic", status: "Under Pipeline" },
            // { id: 9, name: "Atrasentan", category: "Treatment of Proteinuria", status: "Under Pipeline" },
            // { id: 24, name: "Encorafenib", category: "Anti-Neoplastic", status: "Under Pipeline" },
            // { id: 33, name: "Gepotidacin", category: "Anti-Bacterial", status: "Under Pipeline" },
            // { id: 40, name: "Iptacopan", category: "Treatment of Paroxysmal Nocturnal Hemoglobinuria (PNH)", status: "Under Pipeline" },
            // { id: 41, name: "Iron Dextran", category: "Hematinic", status: "Under Pipeline" },
            // { id: 51, name: "Letermovir", category: "Anti-Infective", status: "Under Pipeline" },
            // { id: 65, name: "Neratinib", category: "Anti-Neoplastic", status: "Under Pipeline" },
            // { id: 66, name: "Obicetrapib", category: "Dyslipidemic Agent", status: "Under Pipeline" },
            // { id: 69, name: "Opicapone", category: "Anti-Parkinson", status: "Under Pipeline" },
            // { id: 70, name: "Osimertinib", category: "Anti-Neoplastic", status: "Under Pipeline" },
            // { id: 73, name: "Pitolisant", category: "Treatment of Narcolepsy", status: "Under Pipeline" },
            // { id: 84, name: "Sodium Zirconium Cyclosilicate", category: "Potassium Binder", status: "Under Pipeline" },
            // { id: 85, name: "Selpercatinib", category: "Anti-Neoplastic", status: "Under Pipeline" },
            // { id: 86, name: "Sepiapterin", category: "Treatment of Hyperphenylalaninemia (HPA)", status: "Under Pipeline" },
            // { id: 95, name: "Tranexamic Acid", category: "Anti-Fibrinolytic", status: "Under Pipeline" },
            // { id: 96, name: "Trospium Chloride", category: "Anti-Muscarinic", status: "Under Pipeline" },
            // { id: 97, name: "Vismodegib", category: "Anti-Neoplastic", status: "Under Pipeline" },
            // { id: 103, name: "5-Fluoro Uracil", category: "Anti-Neoplastic", status: "Tech Pack" },
            // { id: 104, name: "Alectinib", category: "Anti-Neoplastic", status: "Tech Pack" },
            // { id: 105, name: "Abemaciclib", category: "Anti-Neoplastic", status: "Tech Pack" },
            // { id: 106, name: "Avapritinib", category: "Anti-Neoplastic", status: "Tech Pack" },
            // { id: 107, name: "Mirogabalin", category: "Treatment of Neuropathic Pain", status: "Tech Pack" },
            // { id: 108, name: "Mirdametinib", category: "Treatment of Neurofibrosis (NF1)", status: "Tech Pack" },
            // { id: 109, name: "Perfluorohexyloctane", category: "Treatment of Dry Eye Disease", status: "Tech Pack" },
            // { id: 110, name: "Ruxolitinib Phosphate/ HCl", category: "Treatment of Myelofibrosis", status: "Tech Pack" },
            // { id: 111, name: "Sparsentan", category: "Treatment of Kidney Disease", status: "Tech Pack" },
            // { id: 112, name: "Trametinib", category: "Anti-Neoplastic", status: "Tech Pack" },
            // { id: 113, name: "Vibegron", category: "Treatment of Overactive Bladder", status: "Tech Pack" },
            // { id: 114, name: "Venetoclax", category: "Anti-Neoplastic", status: "Tech Pack" }
        ]
    },

    {
        category: "CNS",
        products: [
            { name: "Agomelatine (Form I & II)", type: "Anti-Depressant", status: "CNDMF" },
            { name: "Amisulpride", type: "Anti-Psychotic", status: "CEP, EDMF, CNDMF" },
            { name: "Eszopiclone", type: "Hypnotic", status: "USDMF, EDMF, CADIFA" },
            { name: "Iloperidone", type: "Anti-Psychotic", status: "USDMF*" },
            { name: "Lacosamide", type: "Anti-Convulsant", status: "USDMF*, CEP" },
            { name: "Levosulpiride", type: "Anti-Psychotic", status: "EDMF*" },
            { name: "Lisdexamfetamine Dimesylate", type: "Treatment of ADHD", status: "DMF" },
            { name: "Meprobamate", type: "Anti-Anxiety", status: "USDMF" },
            { name: "Mirogabalin", type: "Neuropathic Pain", status: "Tech Pack" },
            { name: "Modafinil", type: "Anti-Depressant", status: "USDMF, CEP" },
            { name: "Opicapone", type: "Anti-Parkinson", status: "Under Pipeline" },
            { name: "Phentermine HCl", type: "Anorexic", status: "USDMF, CADIFA" },
            { name: "Pregabalin", type: "Anti-Convulsant", status: "CEP, DMF" },
            { name: "Sertraline HCl (Form I & II)", type: "Anti-Depressant", status: "USDMF*, CEP" },
            { name: "Tofisopam", type: "Anti-Anxiety", status: "EDMF" },
            { name: "Vilazodone", type: "Anti-Depressant", status: "USDMF*, CADIFA" },
            { name: "Viloxazine HCl", type: "Treatment of ADHD", status: "USDMF*, CADIFA" },
            { name: "Vortioxetine HBr", type: "Anti-Depressant", status: "USDMF*, EDMF, CADIFA" },
            { name: "Xanomeline Tartrate", type: "CNS", status: "DMF" }
        ]
    },


    {
        category: "CV",
        products: [
            { name: "Apixaban", type: "Anti-Coagulant", status: "USDMF*" },
            { name: "Acoramidis", type: "Treatment of Cardiomyopathy", status: "Under Pipeline" },
            { name: "Carvedilol", type: "Anti-Hypertensive", status: "CEP, CADIFA" },
            { name: "Carvedilol Phosphate", type: "Anti-Hypertensive", status: "DMF" },
            { name: "Edoxaban Tosylate", type: "Anti-Coagulant", status: "USDMF*" },
            { name: "Ezetimibe", type: "Dyslipidemic Agent", status: "USDMF*, CADIFA" },
            { name: "Finerenone", type: "Cardiovascular", status: "USDMF*" },
            { name: "Labetalol Hydrochloride", type: "Anti-Hypertensive", status: "USDMF, CEP" },
            { name: "Losartan Potassium", type: "Anti-Hypertensive", status: "USDMF*, CEP" },
            { name: "Mavacamten", type: "Treatment of Heart Pain (OHCM)", status: "USDMF*" },
            { name: "Obicetrapib", type: "Dyslipidemic Agent", status: "Under Pipeline" },
            { name: "Olmesartan Medoxomil", type: "Anti-Hypertensive", status: "USDMF*, CEP" },
            { name: "Rivaroxaban", type: "Anti-Coagulant", status: "USDMF, CEP, EDMF, CADIFA" },
            { name: "Selexipag IH", type: "Pulmonary Hypertension", status: "DMF" },
            { name: "Tranexamic acid", type: "Anti-Fibrinolytic", status: "Under Pipeline" },
            { name: "Ticagrelor", type: "Anti-Platelet", status: "USDMF*, CEP" }
        ]
    },

    {
        category: "GI",
        products: [
            { name: "Cinitapride Hydrogen Tartrate", type: "Prokinetic and antiemetic Agent", status: "EDMF, CNDMF" },
            { name: "Itopride HCl", type: "Gastro Prokinetic Agent", status: "EDMF" },
            { name: "Mosapride Citrate Dihydrate", type: "Gastro Prokinetic Agent", status: "CNDMF" },
            { name: "Ondansetron HCl Dihydrate", type: "Anti Emetic", status: "CEP, CADIFA" },
            { name: "Otilonium Bromide", type: "IBS", status: "USDMF*, CADIFA" },
            { name: "Prucalopride Succinate", type: "GI Prokinetic", status: "USDMF, EDMF, CNDMF" },
            { name: "Racecadotril", type: "Anti Diarrhea", status: "CEP, EDMF, CADIFA, CNDMF" },
            { name: "Vonoprazan Fumarate", type: "Anti-Ulcer", status: "USDMF*, CADIFA" }
        ]
    },

    {
        category: "Anti-Histamine",
        products: [
            { name: "Bilastine (Form I & II)", type: "Anti Histamine", status: "USDMF*, EDMF, CADIFA, CNDMF" },
            { name: "Carbinoxamine Maleate", type: "Anti Histamine", status: "USDMF*" },
            { name: "Hydroxyzine HCl", type: "Anti Histamine", status: "USDMF, CEP, EDMF, CADIFA" },
            { name: "Hydroxyzine Pamoate", type: "Anti Histamine", status: "USDMF*" },
            { name: "Levocetirizine Di HCl", type: "Anti Histamine", status: "USDMF, CEP, EDMF, CADIFA" },
            { name: "Meclizine HCl", type: "Anti Histamine", status: "USDMF, CEP, CADIFA" }
        ]
    },


    {
        category: "Analgesics",
        products: [
            { name: "Ketorolac Tromethamine", type: "NSAID and Anti-inflammatory", status: "USDMF, CEP, EDMF, CADIFA" },
            { name: "Tapentadol HCl (Form-A)", type: "Analgesic & Anti-Inflammatory", status: "CEP, EDMF, CADIFA" },
            { name: "Tapentadol Phosphate", type: "Analgesic & Anti-Inflammatory", status: "EDMF" }
        ]
    },

    {
        category: "Anti-Diabetic",
        products: [
            { name: "Dapagliflozin Propanediol Monohydrate", type: "Anti Diabetic", status: "USDMF*" },
            { name: "Empagliflozin", type: "Anti Diabetic", status: "USDMF*" },
            { name: "Linagliptin", type: "Anti Diabetic", status: "USDMF*" }
        ]
    },

    {
        category: "Anti-Bacterial",
        products: [
            { name: "Linezolid (Form II & III)", type: "Anti-Bacterial", status: "USDMF, EDMF, CADIFA, CNDMF" },
            { name: "Gepotidacin", type: "Anti-Bacterial", status: "Under Pipeline" }
        ]
    },
    {
        category: "Oncology",
        products: [
            { name: "5-Fluoro Uracil", type: "Anti-Neoplastic", status: "Tech Pack" },
            { name: "Abemaciclib", type: "Anti-Neoplastic", status: "Tech Pack" },
            { name: "Alectinib", type: "Anti-Neoplastic", status: "Tech Pack" },
            { name: "Alpelisib", type: "Anti-Neoplastic", status: "Under Pipeline" },
            { name: "Avapritinib", type: "Anti-Neoplastic", status: "Tech Pack" },
            { name: "Dabrafenib", type: "Anti-Neoplastic", status: "DMF" },
            { name: "Encorafenib", type: "Anti-Neoplastic", status: "Under Pipeline" },
            { name: "Neratinib", type: "Anti-Neoplastic", status: "Under Pipeline" },
            { name: "Osimertinib", type: "Anti-Neoplastic", status: "Under Pipeline" },
            { name: "Selpercatinib", type: "Anti-Neoplastic", status: "Under Pipeline" },
            { name: "Trametinib", type: "Anti-Neoplastic", status: "Tech Pack" },
            { name: "Venetoclax", type: "Anti-Neoplastic", status: "Tech Pack" },
            { name: "Vismodegib", type: "Anti-Neoplastic", status: "Under Pipeline" }
        ]
    },

    {
        category: "Others",
        products: [
            { id: 1, name: "Abacavir Sulphate", type: "Anti-Retroviral", status: "CEP, DMF" },
            { id: 2, name: "Aceclidine", type: "Treatment of Presbyopia (Blurry Vision)", status: "Under Pipeline" },
            { id: 3, name: "Ademetionine", type: "Treatment of Liver Disorder, Osteoarthritis & Depression", status: "Under Pipeline" },
            { id: 4, name: "Atrasentan", type: "Treatment of Proteinuria", status: "Under Pipeline" },
            { id: 5, name: "Baclofen", type: "Muscle Relaxant", status: "USDMF, CEP" },
            { id: 6, name: "Brimonidine Tartrate", type: "Anti-Glaucoma", status: "USDMF, CEP, CADIFA" },
            { id: 7, name: "Clomiphene Citrate", type: "Ovulatory Stimulants", status: "USDMF*" },
            { id: 8, name: "Dapoxetine HCl", type: "Treatment of Premature Ejaculation", status: "EDMF, CNDMF" },
            { id: 9, name: "Deferasirox", type: "Iron Chelator", status: "USDMF, CEP, EDMF, CNDMF" },
            { id: 10, name: "Dolutegravir Sodium", type: "Anti-Retroviral", status: "USDMF*" },
            { id: 11, name: "Epalrestat", type: "Aldose Reductase Inhibitor", status: "CNDMF" },
            { id: 12, name: "Ferric Carboxy Maltose", type: "Treatment of Anemia", status: "DMF" },
            { id: 13, name: "Ferric Maltol", type: "Iron Deficiency", status: "DMF" },
            { id: 14, name: "Flibanserin", type: "Female Aphrodisiac", status: "DMF" },
            { id: 15, name: "Glycopyrrolate", type: "Anti Cholinergic", status: "USDMF*" },
            { id: 16, name: "Hydroxychloroquine Sulfate", type: "Anti Malaria", status: "USDMF, CEP" },
            { id: 17, name: "Idrocilamide", type: "Skeletal Muscle Relaxant", status: "DMF" },
            { id: 18, name: "Iptacopan", type: "Treatment of paroxysmal nocturnal hemoglobinuria (PNH)", status: "Under Pipeline" },
            { id: 19, name: "Iron Polymaltose", type: "Hematinic", status: "DMF" },
            { id: 20, name: "Iron Sorbitol Dextrin Citric Acid Complex", type: "Hematinic", status: "DMF" },
            { id: 21, name: "Iron Sucrose LIQ & POW", type: "Hematinic", status: "USDMF*, EDMF" },
            { id: 22, name: "Iron dextran", type: "Hematinic", status: "Under Pipeline" },
            { id: 23, name: "Lamivudine", type: "Anti-Retroviral", status: "USDMF*" },
            { id: 24, name: "Lanthanum Carbonate", type: "Phosphate Binder", status: "USDMF" },
            { id: 25, name: "Levodropropizine", type: "Anti-Tussive", status: "CEP*" },
            { id: 26, name: "Letermovir", type: "Anti-Infective", status: "Under Pipeline" },
            { id: 27, name: "Lopinavir", type: "Anti-Retroviral", status: "DMF" },
            { id: 28, name: "Mirdametinib", type: "Treatment of Neurofibrosis (NF1)", status: "Tech Pack" },
            { id: 29, name: "Perfluorohexyloctane", type: "Treatment of Dry Eye Disease", status: "Tech Pack" },
            { id: 30, name: "Pitolisant", type: "Treatment of Narcolepsy", status: "Under Pipeline" },
            { id: 31, name: "Quinaldic Acid", type: "Anti-Tubercular", status: "DMF" },
            { id: 32, name: "Resmetirom", type: "Treatment of NASH", status: "DMF" },
            { id: 33, name: "Ritonavir", type: "Anti-Retroviral", status: "DMF" },
            { id: 34, name: "Ruxolitinib Phosphate/ HCl", type: "Treatment of Myelofibrosis", status: "Tech Pack" },
            { id: 35, name: "Sepiapterin", type: "Treatment of Hyperphenylalaninemia (HPA)", status: "Under Pipeline" },
            { id: 36, name: "Sod. Zirconium Cyclosilicate", type: "Potassium Binder", status: "Under Pipeline" },
            { id: 37, name: "Sparsentan", type: "Treatment of Kidney Disease", status: "Tech Pack" },
            { id: 38, name: "Sucroferric Oxyhydroxide", type: "Treatment of Hyperphosphatemia", status: "USDMF*" },
            { id: 39, name: "Tamsulosin HCl", type: "Treatment of Benign prostatic hyperplasia (BPH)", status: "DMF" },
            { id: 40, name: "Tenofovir Disoproxil Fumarate", type: "Anti-Retroviral", status: "USDMF*" },
            { id: 41, name: "Trospium Chloride", type: "Anti-Muscarinic", status: "Under Pipeline" },
            { id: 42, name: "Thalidomide", type: "Immunomodulator", status: "EDMF" },
            { id: 43, name: "Tizanidine HCl", type: "Muscle Relaxant", status: "USDMF, CEP, EDMF, CADIFA, CNDMF" },
            { id: 44, name: "Vibegron", type: "Treatment of Overactive bladder", status: "Tech Pack" }
        ]
    },

];

const categorizedAnimalProducts = [
    {
        category: "Commercial API's",
        products: [

        ]
    },
    {
        category: "R&D Pipeline API's",
        products: [

        ]
    },
    {
        category: "Anti-Parasitic",
        color: "#DC2626",
        products: [
            { name: "Albendazole", type: "Anti-Helmintic", status: "US VMF" },
            { name: "Clorsulon", type: "Anti-Helmintic", status: "US VMF, EDMF, CEP" },
            { name: "Closantel Sodium", type: "Anti-Helmintic", status: "Under Advanced Development" },
            { name: "Fenbendazole", type: "Anti-Helmintic", status: "US VMF, CEP" },
            { name: "Febantel", type: "Anti-Helmintic", status: "US VMF, CEP" },
            { name: "Flubendazole", type: "Anti-Helmintic", status: "US VMF, CEP" },
            { name: "Levamisole HCl", type: "Anti-Helmintic", status: "US VMF, CEP" },
            { name: "Nitroxynil", type: "Anti-Helmintic", status: "US VMF, EDMF, CEP" },
            { name: "Nitroscanate", type: "Anti-Helmintic", status: "EDMF" },
            { name: "Oxfendazole", type: "Anti-Helmintic", status: "US VMF, CEP" },
            { name: "Praziquantel", type: "Anti-Helmintic", status: "US VMF, CEP" },
            { name: "Ricobendazole", type: "Anti-Helmintic", status: "VMF" },
            { name: "R-Praziquantel", type: "Anti-Helmintic", status: "VMF" },
            { name: "Triclabendazole", type: "Anti-Helmintic", status: "US VMF, CEP" },
            { name: "Afoxolaner", type: "Anti-Parasites", status: "US VMF" },
            { name: "Esafoxolaner", type: "Anti-Parasites", status: "Under Pipeline" },
            { name: "Fluralaner", type: "Anti-Parasites", status: "US VMF" },
            { name: "Fluazuron", type: "Anti-Parasites", status: "" },
            { name: "Lotilaner", type: "Anti-Parasites", status: "Under Advanced Development" },
            { name: "Lufenuron", type: "Anti-Parasites", status: "US VMF, CEP" },
            { name: "Sarolaner", type: "Anti-Parasites", status: "Under Advanced Development" },
            { name: "S-Methoprene", type: "Anti-Parasites", status: "EDMF" },
            { name: "Tigolaner", type: "Anti-Parasites", status: "Under Pipeline" },
            { name: "Melarsomine HCl", type: "Anti-Parasites", status: "Under Advanced Development" },
            { name: "Buparvaquone", type: "Anti-Protozoal", status: "US VMF" },
            { name: "Diclazuril", type: "Anti-Protozoal", status: "US VMF, CEP" },
            { name: "Diminazene Diaceturate", type: "Anti-Protozoal", status: "" },
            { name: "Imidocarb Dipropionate", type: "Anti-Protozoal", status: "US VMF, EDMF" },
            { name: "Ponazuril", type: "Anti-Protozoal", status: "US VMF" },
            { name: "Parvaquone", type: "Anti-Protozoal", status: "Under Advanced Development" },
            { name: "Toltrazuril", type: "Anti-Protozoal", status: "US VMF" },
        ]
    },

    {
        category: "Anti-Bacterial",
        color: "#0D9488",
        products: [
            { name: "Tildipirosin", type: "Anti-Bacterial", status: "US VMF" },
            { name: "Gamithromycin", type: "Anti-Bacterial", status: "US VMF" },
            { name: "Tulathromycin", type: "Anti-Bacterial", status: "Under Advanced Development" },
            { name: "Orbifloxacin", type: "Anti-Bacterial", status: "Under Pipeline" },
        ]
    },
    {
        category: "Analgesics",
        color: "#2563EB",
        products: [
            { name: "Carprofen", type: "NSAID", status: "US VMF, CEP" },
            { name: "Deracoxib", type: "NSAID", status: "US VMF" },
            { name: "Flunixin Meglumine", type: "NSAID", status: "US VMF, CEP" },
            { name: "Firocoxib", type: "NSAID", status: "US VMF, EDMF" },
            { name: "Grapiprant", type: "NSAID", status: "Under Advanced Development" },
            { name: "Mavacoxib", type: "NSAID", status: "US VMF" },
            { name: "Robenacoxib", type: "NSAID", status: "US VMF, EDMF" },
            { name: "Ketoprofen", type: "NSAID", status: "Under Advanced Development" },
            { name: "Xylazine HCl", type: "Analgesic", status: "US VMF, CEP" },
            { name: "Xylazine USP (Base)", type: "Analgesic", status: "US VMF" },
        ]
    },
    {
        category: "GI",
        color: "#6366F1",
        products: [
            { name: "Maropitant Citrate Monohydrate", type: "Anti Emetic", status: "Under Advanced Development" },
            { name: "Maropitant Base", type: "Anti Emetic", status: "Under Advanced Development" },
            { name: "Pimobendan", type: "Congestive Heart Failure", status: "Under Advanced Development" },
        ]
    },
    {
        category: "Others",
        color: "#6A7282",
        products: [
            { name: "Butaphosphan", type: "Phosphorus Supplement", status: "US VMF, EDMF" },
            { name: "Toldimfos Sodium", type: "Phosphorus Supplement", status: "EDMF" },
            { name: "Ractopamine HCl", type: "Beta Agonist", status: "US VMF" },
            { name: "Zilpaterol HCl", type: "Beta Agonist", status: "US VMF" },
            { name: "Oclacitinib Maleate", type: "Anti-Allergic", status: "Under Advanced Development" },
            { name: "Tolazoline HCl", type: "Pulmonary Vasodilator", status: "Under Advanced Development" },
        ]
    },
];

const categoryColors = {
    "Oncology": "#DC2626",
    "CNS (Central Nervous System)": "#7C3AED",
    "Cardiovascular System (CVS)": "#059669",
    "Gastro / GI": "#0D9488",
    "Anti-Histamine": "#B45309",
    "Pain / NSAID": "#2563EB",
    "Anti-Diabetic": "#0891B2",
    "Anti-Bacterial": "#D97706",
    "Others": "#6A7282"
};

export function useScrollAnimation() {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const element = ref.current;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.unobserve(element);
                }
            },
            { threshold: 0.02, rootMargin: '0px' }
        );

        if (element) observer.observe(element);
        return () => observer.disconnect();
    }, []);

    return [ref, visible];
}

const API = () => {
    const [search, setSearch] = useState("");
    const [ptaSearch, setPTASEarch] = useState("");
    const [selectedCategory, setSelectedCategory] = useState("All Categories");
    const [selectedPTACategory, setSelectedPTACategory] = useState("All Categories");

    const [ref1, visible1] = useScrollAnimation();
    const [ref2, visible2] = useScrollAnimation();
    const [ref3, visible3] = useScrollAnimation();
    const [ref5, visible5] = useScrollAnimation();
    const [ref6, visible6] = useScrollAnimation();
    const [ref7, visible7] = useScrollAnimation();

    const allTherapeuticProducts = categorizedProducts.flatMap(cat =>
        (cat.category !== "Commercial API's" && cat.category !== "R&D Pipeline API's") ? cat.products : []
    );

    const filteredPortfolio = categorizedProducts
        .map(cat => {
            let productsToShow = cat.products;

            if (selectedCategory === "Commercial API's" && cat.category === "Commercial API's") {
                productsToShow = allTherapeuticProducts.filter(p =>
                    !p.status?.toLowerCase().includes("pipeline") &&
                    !p.status?.toLowerCase().includes("tech pack")
                );
            } else if (selectedCategory === "R&D Pipeline API's" && cat.category === "R&D Pipeline API's") {
                productsToShow = allTherapeuticProducts.filter(p =>
                    p.status?.toLowerCase().includes("pipeline") ||
                    p.status?.toLowerCase().includes("tech pack")
                );
            }

            return {
                ...cat,
                products: productsToShow.filter(p =>
                    p.name.toLowerCase().includes(search.toLowerCase()) ||
                    ((p.type || p.category) && (p.type || p.category).toLowerCase().includes(search.toLowerCase()))
                )
            };
        })
        .filter(cat => {
            if (selectedCategory === "All Categories") {
                return cat.category !== "Commercial API's" && cat.category !== "R&D Pipeline API's" && cat.products.length > 0;
            }
            return cat.category === selectedCategory && cat.products.length > 0;
        });

    const allAnimalProducts = categorizedAnimalProducts.flatMap(cat =>
        (cat.category !== "Commercial API's" && cat.category !== "R&D Pipeline API's") ? cat.products : []
    );

    const filteredPTA = categorizedAnimalProducts
        .map(cat => {
            let productsToShow = cat.products;

            if (selectedPTACategory === "Commercial API's" && cat.category === "Commercial API's") {
                productsToShow = allAnimalProducts.filter(p =>
                    !p.status?.toLowerCase().includes("under advanced development")
                );
            } else if (selectedPTACategory === "R&D Pipeline API's" && cat.category === "R&D Pipeline API's") {
                productsToShow = allAnimalProducts.filter(p =>
                    p.status?.toLowerCase().includes("under advanced development")
                );
            }

            return {
                ...cat,
                products: productsToShow.filter(p =>
                    p.name.toLowerCase().includes(ptaSearch.toLowerCase()) ||
                    ((p.type || p.category) && (p.type || p.category).toLowerCase().includes(ptaSearch.toLowerCase()))
                )
            };
        })
        .filter(cat => {
            if (selectedPTACategory === "All Categories") {
                return cat.category !== "Commercial API's" && cat.category !== "R&D Pipeline API's" && cat.products.length > 0;
            }
            return cat.category === selectedPTACategory && cat.products.length > 0;
        });

    const handleDownload = () => {
        const link = document.createElement("a");
        link.href = broucher;
        link.download = "Products-Brochure.pdf";
        link.click();
    };

    return (
        <div className="api-page">
            <section className="api-hero-section">
                <div className="api-hero-overlay"></div>
                <div className="api-hero-content">
                    <h1 className="api-hero-title" style={{ fontSize: "36px" }}>
                        ACTIVE PHARMACEUTICAL INGREDIENTS (APIs)
                    </h1>
                    <p className="api-hero-description">Our product portfolio comprises Commercial APIs and R&D / Pipeline APIs across various <br /> Drug Categories.</p>
                </div>
            </section>

            <div className="api-breadcrumb-container" >
                <div className="api-breadcrumb-wrapper">
                    <Link to="/" className="api-breadcrumb-link api-home-link">
                        <HomeIcon /> Home
                    </Link>
                    <span className="api-breadcrumb-separator" style={{ padding: "10px" }}>›</span>
                    <span className="api-breadcrumb-current">API</span>
                </div>
            </div>

            <section id="api-portfolio" ref={ref1} className={`api-portfolio-section reveal reveal-up ${visible1 ? "reveal-visible" : ""}`} >
                <div className="api-portfolio-container">
                    <h2 className="api-title" style={{ fontSize: "36px" }}>API Portfolio, Strength & Capabilities</h2>
                    <div className="api-divider-container">
                        <span className="api-divider-line left"></span>
                        <div className="api-divider-icon">
                            <img src={minLogo} style={{ width: "28px", height: "22px" }} alt="company overview" />
                        </div>
                        <span className="api-divider-line right"></span>
                    </div>

                    <p className="api-subtitle" style={{ fontSize: "20px" }}>
                        Comprehensive overview of Viyash’s Human Health API portfolio, supported by regulatory expertise, robust R&D, and integrated manufacturing capabilities.
                    </p>
                    <div className="api-table-section">
                        <div className="api-filter-container">
                            {/* <h2 style={{ fontSize: "18px", color: "#1F2937", margin: 0 }}>Human Health API Categories</h2> */}
                            <div className="api-filter-controls">
                                <div className="api-category-pills">
                                    <button
                                        className={`api-filter-pill ${selectedCategory === "All Categories" ? "active" : ""}`}
                                        onClick={() => setSelectedCategory("All Categories")}
                                    >
                                        All
                                    </button>
                                    {categorizedProducts.map((cat, idx) => (
                                        <button
                                            key={idx}
                                            className={`api-filter-pill ${selectedCategory === cat.category ? "active" : ""}`}
                                            onClick={() => setSelectedCategory(cat.category)}
                                        >
                                            {cat.category}
                                        </button>
                                    ))}
                                </div>
                                <div className="api-search-box">
                                    <FiSearch className="api-search-icon" />
                                    <input
                                        type="text"
                                        placeholder="Search products..."
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                    {search && <span className="clear-search" onClick={() => setSearch("")}>×</span>}
                                </div>
                            </div>
                        </div>
                        <div className="api-table-header">
                            <p className="api-table-header-text" >
                                Showing <b className="api-table-header-text-b">{filteredPortfolio.reduce((acc, group) => acc + group.products.length, 0)}</b> products ·{" "}
                                <span className="api-table-header-text-span">{selectedCategory}</span>
                            </p>
                            <span
                                className="clear"
                                onClick={() => {
                                    setSearch("");
                                    setSelectedCategory("All Categories");
                                }}
                            >
                                Clear filters
                            </span>
                        </div>

                        <section className="api-portfolio-table-section">
                            <div className="api-table-wrapper">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Product Name</th>
                                            <th>Category</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredPortfolio.flatMap(group => group.products).map((product, idx) => (
                                            <tr key={idx}>
                                                <td>{idx + 1}</td>
                                                <td>{product.name}</td>
                                                <td><span className="api-badge">{product.type || product.category}</span></td>
                                                <td className="api-status-text">{product.status}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </section>
                    </div>

                    <div className="api-footer">
                        <p className="api-disclaimer" style={{ textAlign: "left" }}>
                            <b>USDMF/CEP/EDMF:</b> Approved | <b>USDMF*/CEP*/EDMF*:</b> <b>Filed /</b>
                            <b>Under-approval</b> <br />
                            <span>Disclaimer:</span> Viyash Scientific Ltd. Private Limited and its subsidiaries respect the intellectual property rights of others. No information in this catalog (including any reference to any product or service) constitutes an offer for sale of products protected under valid patents are not offered or supplied for commercial use. However, the research quantities of such products may be offered for the purpose of regulatory submissions. Wherever such regulatory exemptions exist, the buyer should make their independent evaluation of the patent scenario for their respective markets and will be responsible for all patent related liabilities
                        </p>
                    </div>

                    <div ref={ref7} className={`api-download-banner reveal reveal-up ${visible7 ? "reveal-visible" : ""}`} >
                        <div className="api-banner-left" style={{ textAlign: "left" }}>
                            <h2>Download Products PDF</h2>
                            <p>
                                Get our complete API product portfolio brochure including
                                specifications and regulatory data.
                            </p>
                        </div>
                        <button className="api-download-btn" onClick={handleDownload}>
                            <img src={downloadIcon} alt="Download" className="api-download-icon" />
                            Download Brochure
                        </button>
                    </div>
                </div>
            </section>

            <section id="pta-section" ref={ref5} className={`pta-section reveal reveal-up ${visible5 ? "reveal-visible" : ""}`}>
                <h2 className="pta-title">Products & Therapeutic Areas</h2>
                <div className="pta-divider">
                    <span className="pta-line left"></span>
                    <div className="pta-logo">
                        <img src={minImage} alt="logo" />
                    </div>
                    <span className="pta-line right"></span>
                </div>

                <p className="pta-subtitle">
                    40 commercial APIs, New pipeline focused on Companion Animals
                </p>

                <div className={`pta-banner reveal reveal-up ${visible5 ? "reveal-visible" : ""}`}>
                    <div className="pta-banner-header">
                        <img src={moleculesIcon} alt="flask" />
                        <h4>12 molecules under active development</h4>
                    </div>
                    <p>
                        70% of our new Animal Health pipeline is focused on Companion Animals,
                        addressing growing demand for pet therapeutics in key regulated markets.
                    </p>
                </div>

                <div className="api-table-section">
                    <div className="api-filter-container">
                        {/* <h2 style={{ fontSize: "18px", color: "#1F2937", margin: 0 }}>Animal Health Categories</h2> */}
                        <div className="api-filter-controls" style={{ justifyContent: "flex-start", gap: "150px" }}>
                            <div className="api-category-pills">
                                <button
                                    className={`api-filter-pill ${selectedPTACategory === "All Categories" ? "active" : ""}`}
                                    onClick={() => setSelectedPTACategory("All Categories")}
                                >
                                    All
                                </button>
                                {categorizedAnimalProducts.map((cat, idx) => (
                                    <button
                                        key={idx}
                                        className={`api-filter-pill ${selectedPTACategory === cat.category ? "active" : ""}`}
                                        onClick={() => setSelectedPTACategory(cat.category)}
                                    >
                                        {cat.category}
                                    </button>
                                ))}
                            </div>
                            <div className="api-search-box">
                                <FiSearch className="api-search-icon" />
                                <input
                                    type="text"
                                    placeholder="Search products..."
                                    value={ptaSearch}
                                    onChange={(e) => setPTASEarch(e.target.value)}
                                />
                                {ptaSearch && <span className="clear-search" onClick={() => setPTASEarch("")}>×</span>}
                            </div>
                        </div>
                    </div>

                    <div className="api-table-header">
                        <p className="api-table-header-text">
                            Showing <b className="api-table-header-text-b">{filteredPTA.reduce((acc, group) => acc + group.products.length, 0)}</b> products ·{" "}
                            <span className="api-table-header-text-span">{selectedPTACategory}</span>
                        </p>
                        <span
                            className="clear"
                            onClick={() => {
                                setPTASEarch("");
                                setSelectedPTACategory("All Categories");
                            }}
                        >
                            Clear filters
                        </span>
                    </div>

                    <section className="api-pta-table-section">
                        <div className="api-table-wrapper">
                            <table>
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Product Name</th>
                                        <th>Category</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredPTA.flatMap(group => group.products).map((product, idx) => (
                                        <tr key={idx}>
                                            <td>{idx + 1}</td>
                                            <td>{product.name}</td>
                                            <td><span className="api-badge">{product.type || product.category}</span></td>
                                            <td className="api-status-text">{product.status}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </section>
                </div>
            </section>

            <div ref={ref6} className={`api-intermediates-container reveal reveal-up ${visible6 ? "reveal-visible" : ""}`}>
                <div className="api-portfolio-container">
                    <h2 className="api-portfolio-title">Intermediates Portfolio</h2>
                    <div className="api-divider-container">
                        <span className="api-divider-line left"></span>
                        <div className="api-divider-icon">
                            <img src={minLogo} style={{ width: "28px", height: "22px" }} alt="company overview" />
                        </div>
                        <span className="api-divider-line right"></span>
                    </div>
                    <p className="api-portfolio-description">
                        Key intermediates supporting the manufacturing of Viyash Human Health
                        APIs. Our intermediates portfolio supports the synthesis of multiple
                        APIs and reflects our strong process chemistry capabilities and
                        backward integration.
                    </p>
                    <button className="api-portfolio-button">
                        <a href="/intermediates" style={{ color: '#fff', textDecoration: 'none' }}>Read More</a>
                    </button>
                </div>
            </div>

            <div className="api-section-line"></div>

            <div ref={ref2} className={`api-strength-container reveal reveal-up ${visible2 ? "reveal-visible" : ""}`}>
                <h3 className="api-portfolio-title" style={{ textAlign: "center" }}>Portfolio</h3>
                <div className="wrapper">
                    <div className="api-grid" >


                        {stats.map((item, index) => (
                            <div className={`api-card reveal ${index % 2 === 0 ? "reveal-left" : "reveal-right"} ${visible2 ? "reveal-visible" : ""}`} key={index} style={{ transitionDelay: `${index * 0.1}s` }}>
                                <div style={{ display: "flex", alignItems: "flex-start", marginTop: "5px" }}>
                                    <div
                                        className="api-icon-box"
                                        style={{ background: `${item.color}20`, color: item.color }}
                                    >
                                        {item.icon}
                                    </div>
                                </div>
                                <div className="api-content">
                                    <h2 style={{ color: item.color }}>
                                        <AnimatedCounter value={item.value} />
                                    </h2>
                                    <h4>{item.title}</h4>
                                    <p>{item.subtitle}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <h2 className="api-strength-title">Regulatory & IP Strength</h2>
                <div className="wrapper">
                    <div className="api-strength-grid-two">
                        <div className={`api-strength-card reveal reveal-left ${visible2 ? "reveal-visible" : ""}`} style={{ fontSize: "12.4px", color: "black" }}>
                            <div className="api-strength-card-header">
                                <img src={regulatoryStrengthIcon} alt="Regulatory" style={{ width: "18px", height: "18px", marginRight: "10px" }} />
                                <h4>Regulatory Filings Across Geographies</h4>
                            </div>
                            <div className="api-pill-grid" >
                                <div className="api-pill" style={{ border: "1px solid #E5EAF2" }}><b style={{ fontSize: "20px" }}><AnimatedCounter value="48" /></b> USDMF</div>
                                <div className="api-pill" style={{ border: "1px solid #E5EAF2" }}><b style={{ fontSize: "20px" }}><AnimatedCounter value="31" /></b> USVMF</div>
                                <div className="api-pill" style={{ border: "1px solid #E5EAF2" }}><b style={{ fontSize: "20px" }}><AnimatedCounter value="40" /></b> CEP</div>
                                <div className="api-pill" style={{ border: "1px solid #E5EAF2" }}><b style={{ fontSize: "20px" }}><AnimatedCounter value="42" /></b> EDMF</div>
                                <div className="api-pill" style={{ border: "1px solid #E5EAF2" }}><b style={{ fontSize: "20px" }}><AnimatedCounter value="15" /></b> CADIFA</div>
                                <div className="api-pill" style={{ border: "1px solid #E5EAF2" }}><b style={{ fontSize: "20px" }}><AnimatedCounter value="16" /></b> CNDMF</div>
                                <div className="api-pill" style={{ border: "1px solid #E5EAF2" }}><b style={{ fontSize: "20px" }}><AnimatedCounter value="9" /></b> KDMF</div>
                            </div>
                        </div>
                        <div className={`api-strength-card reveal reveal-right ${visible2 ? "reveal-visible" : ""}`}>
                            <div className="api-strength-card-header">
                                <img src={ipStrengthIcon} alt="IP Strength" style={{ width: "24px", height: "24px", marginRight: "10px" }} />
                                <h4>Intellectual Property Strength</h4>
                            </div>
                            <div className="api-ip-box">
                                <div className="api-ip-box-icon">
                                    <img src={patentFiledIcon} alt="Patents Filed" style={{ width: "24px", height: "24px" }} />
                                </div>
                                <div className="api-ip-box-content">
                                    <b><AnimatedCounter value="190+" /></b>
                                    <span>Patents Filed</span>
                                </div>
                            </div>
                            <div className="api-ip-box">
                                <div className="api-ip-box-icon">
                                    <img src={patentGrantedIcon} alt="Patents Granted" style={{ width: "24px", height: "24px" }} />
                                </div>
                                <div className="api-ip-box-content">
                                    <b><AnimatedCounter value="55+" /></b>
                                    <span>Patents Granted Globally</span>
                                </div>
                            </div>
                            <div className="api-ip-box">
                                <div className="api-ip-box-icon">
                                    <img src={successfulPatentIcon} alt="Litigations" style={{ width: "24px", height: "24px" }} />
                                </div>
                                <div className="api-ip-box-content">
                                    <b><AnimatedCounter value="26+" /></b>
                                    <span>Successful Patent Litigations</span>
                                </div>
                            </div>
                            <p className="api-ip-desc">
                                Extensive experience in patent litigation, lifecycle management,
                                and regulatory filings across major global markets.
                            </p>
                        </div>
                    </div>
                </div>

                <h2 className="api-strength-title">Research & Development Strength</h2>
                <div className="api-strength-grid-three">
                    <div className={`api-strength-card reveal reveal-left ${visible2 ? "reveal-visible" : ""}`}>
                        <div className="api-strength-card-header">
                            <img src={workforceIcon} alt="Workforce" style={{ width: "24px", height: "24px", marginRight: "10px", background: "#EEF4FF;" }} />
                            <h4>Workforce</h4>
                        </div>
                        <div className="api-stats-row" >
                            <div className="api-stat-box" style={{ justifyContent: "flex-start" }}>
                                <b><AnimatedCounter value="180+" /></b>
                                <span>Scientists</span>
                            </div>
                            <div className="api-stat-box" style={{ justifyContent: "flex-start" }}>
                                <b><AnimatedCounter value="20+" /></b>
                                <span>PhDs</span>
                            </div>
                            <div className="api-stat-box" style={{ justifyContent: "flex-start" }}>
                                <b><AnimatedCounter value="220+" /></b>
                                <span>Total R&D Workforce</span>
                            </div>
                        </div>
                        <h5 className="api-dept-title">DEPARTMENT DISTRIBUTION</h5>
                        <div className="api-dept">
                            <div className="api-dept-row"><label>Chemical R&D</label><span>56</span></div>
                            <div className="api-bar"><div className="api-progress" style={{ width: "86%" }}></div></div>
                        </div>
                        <div className="api-dept">
                            <div className="api-dept-row"><label>Analytical R&D</label><span>65</span></div>
                            <div className="api-bar"><div className="api-progress" style={{ width: "95%" }}></div></div>
                        </div>
                        <div className="api-dept">
                            <div className="api-dept-row"><label>Process Development</label><span>38</span></div>
                            <div className="api-bar"><div className="api-progress" style={{ width: "60%" }}></div></div>
                        </div>
                        <div className="api-dept">
                            <div className="api-dept-row"><label>IP Management</label><span>5</span></div>
                            <div className="api-bar"><div className="api-progress" style={{ width: "10%" }}></div></div>
                        </div>
                        <div className="api-dept">
                            <div className="api-dept-row"><label> Process Safety</label><span>3</span></div>
                            <div className="api-bar"><div className="api-progress" style={{ width: "5%" }}></div></div>
                        </div>

                    </div>
                    <div className={`api-strength-card reveal reveal-up ${visible2 ? "reveal-visible" : ""}`}>
                        <div className="api-strength-card-header">
                            <img src={infrastructureIcon} alt="Infrastructure" style={{ width: "24px", height: "24px", marginRight: "10px" }} />
                            <h4>Infrastructure</h4>
                        </div>
                        <div className="api-pill big"><b style={{ color: "#29b61cff", fontSize: "25px" }}><AnimatedCounter value="13" /></b> Chemical Research Labs</div>
                        <div className="api-pill big"><b style={{ color: "#29b61cff", fontSize: "25px" }}><AnimatedCounter value="64" /></b> Fume Hoods</div>
                        <div className="api-pill big"><b style={{ color: "#29b61cff", fontSize: "25px" }}><AnimatedCounter value="20" /></b> Analytical Labs</div>
                        <div className="api-pill big">– Dedicated Cytotoxic Handling Lab</div>
                    </div>
                    <div className={`api-strength-card reveal reveal-right ${visible2 ? "reveal-visible" : ""}`}>
                        <div className="api-strength-card-header">
                            <img src={analyticsIcon} alt="Analytical Instruments" style={{ width: "24px", height: "24px", marginRight: "10px" }} />
                            <h4>Analytical Instruments</h4>
                        </div>
                        <div className="api-pill-grid">
                            <div className="api-pill"><b style={{ color: "#5c0a8eff", fontSize: "25px" }}>24</b> HPLC</div>
                            <div className="api-pill"><b style={{ color: "#5c0a8eff", fontSize: "25px" }}>9</b> GC</div>
                            <div className="api-pill"><b style={{ color: "#5c0a8eff", fontSize: "25px" }}>3</b> LCMS</div>
                            <div className="api-pill"><b style={{ color: "#5c0a8eff", fontSize: "25px" }}>1</b> GCMS</div>
                            <div className="api-pill"><b style={{ color: "#5c0a8eff", fontSize: "25px" }}>1</b> PXRD</div>
                            <div className="api-pill"><b style={{ color: "#5c0a8eff", fontSize: "25px" }}>1</b> DSC</div>
                            <div className="api-pill"><b style={{ color: "#5c0a8eff", fontSize: "25px" }}>1</b> FT-Raman</div>
                            <div className="api-pill"><b style={{ color: "#5c0a8eff", fontSize: "25px" }}>1</b> FT-IR</div>
                            <div className="api-pill"><b style={{ color: "#5c0a8eff", fontSize: "25px" }}>1</b> UV Spectrophotometer</div>
                            <div className="api-pill"><b style={{ color: "#5c0a8eff", fontSize: "25px" }}>1</b> ICPMS</div>
                            <div className="api-pill"><b style={{ color: "#5c0a8eff", fontSize: "25px" }}>1</b> AAS</div>
                            <div className="api-pill"><b style={{ color: "#5c0a8eff", fontSize: "25px" }}>2</b> Prep HPLC</div>

                        </div>
                    </div>
                </div>
            </div>

            <div ref={ref3} className={`api-network-container reveal reveal-up ${visible3 ? "reveal-visible" : ""}`} style={{ paddingLeft: "60px", paddingRight: "60px" }}>
                <h2 className="api-network-title">Global API Manufacturing Network</h2>
                <div className="api-network-card">
                    <div className="api-network-stats" >
                        {manufacturingStats.map((item, index) => (
                            <div key={index} className={`api-network-stat reveal reveal-up ${visible3 ? "reveal-visible" : ""}`} style={{ transitionDelay: `${index * 0.1}s` }}>
                                <div className="api-icon-circle-1">{item.icon}</div>
                                <h3><AnimatedCounter value={item.value} /></h3>
                                <p>{item.label}</p>
                            </div>
                        ))}
                    </div>
                    <div className="api-network-description">
                        <div className="api-network-description-inner">
                            <p>
                                With a strengthened network of 10 manufacturing sites across India,
                                Viyash is fully self-reliant and backward integrated — bringing
                                critical intermediate stages in-house for greater control,
                                reliability and speed.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default API;

